"use client";

import { Leaderboard } from "@/components/leaderboard/leaderboard";
import { Card, CardContent } from "@/components/shadcn/card";
import { Separator } from "@/components/shadcn/separator";
import { Tabs, TabsList, TabsTrigger } from "@/components/shadcn/tabs";
import {
    isPuzzleTypeFilter,
    type PuzzleTypeFilter,
} from "@/lib/leaderboard/boards";
import { Trophy } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";

export default function PuzzleLeaderboard() {
    const t = useTranslations("home");
    const [filter, setFilter] = useState<PuzzleTypeFilter>("all");

    return (
        <Card className="h-full" data-testid="homepage-puzzle-leaderboard">
            <CardContent className="flex h-full flex-col gap-4">
                <div className="flex items-center gap-2">
                    <Trophy
                        className="text-primary size-5"
                        aria-hidden="true"
                    />
                    <h3 className="font-medium">{t("puzzleLeaderboard")}</h3>
                </div>
                <Separator />
                <Tabs
                    value={filter}
                    onValueChange={(value) => {
                        if (isPuzzleTypeFilter(value)) setFilter(value);
                    }}
                >
                    <TabsList className="w-full">
                        <TabsTrigger value="all">{t("all")}</TabsTrigger>
                        <TabsTrigger value="positional">
                            {t("filterPositional")}
                        </TabsTrigger>
                        <TabsTrigger value="tactic">
                            {t("filterTactic")}
                        </TabsTrigger>
                    </TabsList>
                </Tabs>
                <Leaderboard board={{ kind: "puzzles", type: filter }} />
            </CardContent>
        </Card>
    );
}
